import { useQuery } from 'react-query';
import { useLocalStorage } from 'usehooks-ts';

import { CONFIG_STALE_TIME } from 'core/constants';
import { LocalStorageKeys } from 'core/enums';
import { configService } from 'core/services';
import { getLogoPaths } from 'core/utils';

export const useGetLogoPaths = () => {
  const [logoPaths, setLogoPaths] = useLocalStorage(LocalStorageKeys.LOGO_PATHS, {});

  const { isError, isLoading } = useQuery(
    ['logoPaths'],
    ({ signal }) => configService.getLogoPaths(signal),
    {
      keepPreviousData: true,
      staleTime: CONFIG_STALE_TIME,
      onSuccess: (data) => {
        setLogoPaths(getLogoPaths(data));
      },
    }
  );

  return {
    logoPaths: logoPaths,
    logoPathsError: isError,
    logoPathsLoading: isLoading,
  };
};
